module.exports = __webpack_public_path__ + "static/media/Monitors.8024e4ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Images/Monitors.png
// module id = 641
// module chunks = 0